import { AfterViewInit, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-tahun-anggaran',
  templateUrl: './tahun-anggaran.component.html',
  styleUrls: ['./tahun-anggaran.component.scss']
})
export class TahunAnggaranComponent implements AfterViewInit {
  @ViewChild('modalKonfirmasiSave') modal: ModalDirective;
  @Output() openModalEvent = new EventEmitter();
  yearList: any;
  penggunaForm: FormGroup;
  aplikasiForm: FormGroup;
  nrk: any;
  tahunAnggaran: any = localStorage.getItem('defaultYear')?.replace(/\D/g, '');
  initialTahunAnggaran: any;
  tahunAnggaranPreviousStatus: boolean;

  constructor(private _router: Router, private spinner: NgxSpinnerService) {
    const dateYear = new Date().getFullYear();
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser) {

      this.nrk = currentUser.pengguna.nrk;

      const currentYear = new Date().getFullYear();
      this.yearList = [currentYear - 1, currentYear, currentYear + 1];

      this.tahunAnggaran = (/^\d{4}$/).test(localStorage.getItem('tahunAnggaran')) ? localStorage.getItem('tahunAnggaran') : (localStorage.removeItem('tahunAnggaran'), null);

      this.penggunaForm = new FormGroup({
        nrk: new FormControl(currentUser.pengguna.nrk),
        jabatan: new FormControl(currentUser.pengguna.jabatan),
        nip: new FormControl(currentUser.pengguna.nip),
        nama: new FormControl(currentUser.pengguna.nama),
      });

      this.aplikasiForm = new FormGroup({
        tahunAnggaran: new FormControl(this.tahunAnggaran, [Validators.required]),
      });

      this.openModalEvent.subscribe(() => {
        this.initialTahunAnggaran = this.tahunAnggaran;
        this.modal.show();
      });

      const storedStatus = localStorage.getItem('enableStahunAnggaranPrevious');
      if (storedStatus === null || storedStatus === undefined) {
        localStorage.setItem('enableStahunAnggaranPrevious', 'false');
        this.tahunAnggaranPreviousStatus = false;
      } else {
        this.tahunAnggaranPreviousStatus = storedStatus === 'true';
      }
    }
  }

  ngAfterViewInit() {
    if (!this.tahunAnggaran) {
      // console.log('Tahun Anggaran is not set');
      this.modal.show();
    }

    this.modal.onHide.subscribe(() => {
      this.aplikasiForm.get('tahunAnggaran').setValue(this.initialTahunAnggaran);
    });
  }

  saveTahunAnggaran() {
    const tahunAnggaran = Number(this.aplikasiForm.get('tahunAnggaran').value);
    localStorage.setItem('tahunAnggaranPrevious', (tahunAnggaran - 1).toString());
    localStorage.setItem('tahunAnggaran', tahunAnggaran.toString());
    localStorage.setItem('tahunAnggaranNext', (tahunAnggaran + 1).toString());
    window.location.reload();
  }

  onCheckboxChange() {
    localStorage.setItem('enableStahunAnggaranPrevious', this.tahunAnggaranPreviousStatus.toString());
  }
}